import React, { useEffect } from 'react';
import Page500 from '@lwtears/lwt-common-frontend/lib/Page500';
import { useErrorActions, useErrorDetails } from '../../providers/ErrorProvider';

const ErrorPage: React.FC = () => {
  const errorDetails = useErrorDetails();
  const { setError } = useErrorActions();

  useEffect(() => {
    return () => {
      setError(undefined, undefined, undefined);
    };
  }, [setError]);

  return <Page500 errorDetails={errorDetails} />;
};

export default ErrorPage;
